export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6678.07c93050.jpg";